export function getStaleTime(minutes: number) {
  const max = minutes * 60 * 1000;
  const min = max - max * 0.2;
  return {
    staleTime: Math.floor(Math.random() * (max - min + 1)) + min,
    cacheTime: Math.max(120_000, max * 2),
  };
}
